<ng-container *ngIf="simWizardDataService.init$ | async as init">
  <app-loading *ngIf="init.isLoading"></app-loading>
  <app-error *ngIf="init.error as error" [error]="error"></app-error>

  <ng-container *ngIf="init.didSucceed">
    <div class="stepper-wrapper">
      <mat-stepper
        orientation="horizontal"
        (selectionChange)="selectionChange($event)"
        [selectedIndex]="simWizardDataService.zimWizard.currentPage.id"
        [linear]="false"
        #stepper
      >
        <mat-step
          [stepControl]="simWizardDataService.zimWizard.formGroup.get('p')"
          errorMessage="Select a pattern configuration"
        >
          <!-- PATTERNS -->
          <ng-template matStepLabel>
            <div class="main">
              {{ simWizardDataService.zimWizard.navItemsConfig[0].header }}
            </div>
            <div
              class="second"
              *ngIf="simWizardDataService.zimWizard.patterns.length"
            >
              <b>{{ simWizardDataService.zimWizard.patterns.length }}</b>
              selected
            </div>
          </ng-template>
          <ng-template matStepContent>
            <app-select-patterns class="pattern-selector"></app-select-patterns>
          </ng-template>
        </mat-step>
        <mat-step
          [stepControl]="simWizardDataService.zimWizard.formGroup.get('hw')"
          errorMessage="Select a hardware configuration"
        >
          <!-- HARDWARES -->
          <ng-template matStepLabel>
            <div class="main">
              {{ simWizardDataService.zimWizard.navItemsConfig[1].header }}
            </div>
            <div
              class="second"
              *ngIf="simWizardDataService.zimWizard.hardwares.length"
            >
              <b>{{ simWizardDataService.zimWizard.hardwares.length }}</b>
              selected
            </div>
          </ng-template>
          <ng-template matStepContent>
            <app-select-hardware
              class="hardware-selector"
            ></app-select-hardware>
          </ng-template>
        </mat-step>
        <mat-step
          [stepControl]="simWizardDataService.zimWizard.formGroup.get('sw')"
          errorMessage="Select a software configuration"
        >
          <!-- SOFTWARES -->
          <ng-template matStepLabel>
            <div class="main">
              {{ simWizardDataService.zimWizard.navItemsConfig[2].header }}
            </div>
            <div
              class="second"
              *ngIf="
                simWizardDataService.zimWizard.softwares.length ||
                simWizardDataService.zimWizard.softwarePresets.length
              "
            >
              <b>{{
                simWizardDataService.zimWizard.softwares.length +
                  simWizardDataService.zimWizard.softwarePresets.length
              }}</b>
              selected
            </div>
          </ng-template>
          <app-select-software class="software-selector"></app-select-software>
        </mat-step>
        <mat-step>
          <!-- SUMMARY -->
          <ng-template matStepLabel>{{
            simWizardDataService.zimWizard.navItemsConfig[3].header
          }}</ng-template>
          <app-simulation-wizard-summary
            class="wizard-summary"
          ></app-simulation-wizard-summary>
        </mat-step>
      </mat-stepper>
    </div>
    <app-wizard-bottom-navbar
      [title]="
        simWizardDataService.zimWizard.navItemsConfig[stepper.selectedIndex]
          .header
      "
      [secondaryButton]="stepper.selectedIndex > 0 ? 'back' : null"
      [primaryButton]="
        simWizardDataService.zimWizard.navItemsConfig[stepper.selectedIndex]
          .button.text
      "
      [primaryButtonDisabled]="isNextButtonDisabled(stepper.selectedIndex)"
      (nextClick)="nextClick(stepper)"
      (backClick)="backClick(stepper)"
    ></app-wizard-bottom-navbar>
  </ng-container>
</ng-container>
